import React from "react";
import CDUnLicensed from "./CDUnLicensed";

function ContinuousDelivery() {
  return <CDUnLicensed />;
}

export default ContinuousDelivery;
